import { useMutation, useQueryClient } from '@tanstack/react-query'
import { postJSON } from '@/lib/api'

export function useBlastDuplicate<T>(onDuplicated: (blast: T) => void) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: number) => postJSON<{ blast: T }>(`/api/v1/blasts/${id}/duplicate`, {}),
    onSuccess: ({ blast }) => {
      queryClient.invalidateQueries({ queryKey: ['blasts'] })
      onDuplicated(blast)
    },
  })
}

export function firstError(...errors: Array<Error | null>): Error | null {
  return errors.find((error) => error !== null) ?? null
}
